export default "/_next/static/sounds/rory-answeryourphone-ef027bb6a2a95a1e99836ea8d8bc798e.mp3";